import MainMenuBlock from '../mainMenuBlock/MainMenuBlock';
import _ from 'underscore';
import {HOTEL_DETAILS, DESTINATIONS_TREE} from "../../globals/widgetTypes";


const TIME_TO_WAIT_ON_KEY_MS = 500;

export default MainMenuBlock.extend(
	/**
	 * @lends core.components.MainMenu
	 */
	{
		template: require('./mainBox.hbs'),
		componentClass: 'mainBox',

		events: {
			'focusin .lmm-search-text-input': 'onFocusAutoComplete',
			'keyup .lmm-search-text-input': 'onInputKeyUp',
			'blur .lmm-search-text-input': 'onBlurAutoComplete',
			'click .reset': 'openPanelHotelDetail',
			'click .mainBox-arrow-back': 'clickInBackBtn'
		},

		constructor(options) {
			MainMenuBlock.prototype.constructor.call(this, options);
			this.classPrefix = '.mainBox-';
			this.widget.map.addListener('click', () => {
				this.$el.find('.lmm-search-text-input').blur();
				this.closeCategoriesPanel();
			});
		},

		createConfigSubcomponents() {
			this.components = {
				Autocomplete: {
					position: 'autocomplete',
					componentConstructorClass: 'Autocomplete',
					identifier: 'Autocomplete',
					properties: {
						providers: {
							ListCategoriesProvider: {
								minLength: 3,
								maxResults: 5
							},
							GPlacesAutocomplete: {
								minLength: 3,
								maxResults: 5
							},
                            ListHotelsProvider: {
                                minLength: 1,
                                maxResults: 5
							}
						}
					},
					resultsPanel: this.$el.find('.mainBox-result'),
					errorPanel: this.$el.find('.mainBox-no-result')
				},
				CategoriesPanel: {
					position: 'categories-panel',
					componentConstructorClass: 'CategoriesPanel',
					identifier: 'CategoriesPanel',
					parent: this
				}
			};
			if (!this.widget.isMobileVersion) {
				this.components.ToggleBtn = {
					position: 'directions',
					componentConstructorClass: 'ToggleBtn',
					properties: {
						event: 'directions_btn_event',
						iconClassName: 'ic_directions'
					}
				};

				this.components.HotelDetailPanel = {
					position: 'hotel-detail-panel',
					componentConstructorClass: 'HotelDetailPanel',
					identifier: 'HotelDetailPanel',
					parent: this
				};
			}
		},

        initialize(options) {
            this.templateConfig.resultHeight = this.widget.getHeight();
            this.templateConfig.isMobileVersion = this.widget.isMobileVersion;
            MainMenuBlock.prototype.initialize.call(this, options);
            this.timer = null;
            this.listenTo(this.bus, 'SHOW_RESULTS_LIST', () => {
                this.$el.find('.lmm-main-box-hotel-detail-panel').hide();
            });
            this.listenTo(this.bus, 'RESET_AUTOCOMPLETE', () => {
                this.$el.find('.mainBox-hotel-detail-panel').show();
                if (this.widget.typeWidget === HOTEL_DETAILS && this.widget.isMobileVersion) {
                    this.widget.$el.find('.lmm-hotel-resume-mobile-panel-hotel-summary-panel').show();
                }
            });
            this.listenTo(this.bus, 'SELECT_RESULT', () => {
                    this.openPanelHotelDetail();
                    this.closeCategoriesPanel();
            });
        },

        onFocusAutoComplete() {
            if (!this.components.Autocomplete.input.val()) {
                this.$el.find('.mainBox-categories-panel').show();
                this.closePanelHotelDetail();
            }
        },

        openPanelHotelDetail() {
            if (this.widget.typeWidget !== DESTINATIONS_TREE && this.widget.isMobileVersion ||
				!this.components.HotelDetailPanel.onClose) {
                this.$el.find('.mainBox-hotel-detail-panel').show();
                this.$el.find('.lmm-main-box-hotel-detail-panel').show();
            }
        },

        closePanelHotelDetail() {
            this.$el.find('.mainBox-hotel-detail-panel').hide();
            this.$el.find('.lmm-main-box-hotel-detail-panel').hide();
        },

		openCategoriesPanel() {
            if (!this.components.Autocomplete.input.val()) {
                this.$el.find('.mainBox-categories-panel').show();
            }
            this.closePanelHotelDetail();
		},

		closeCategoriesPanel() {
            if (!this.components.Autocomplete.input.val()) {
                this.openPanelHotelDetail();
            }
			this.$el.find('.mainBox-categories-panel').hide();
		},

		onInputKeyUp() {
			if (!this.components.Autocomplete.input.val()) {
				if (this.timer) {
					clearTimeout(this.timer);
					this.timer = null;
				}
				this.timer = setTimeout(
					_.bind(this.openCategoriesPanel, this),
					TIME_TO_WAIT_ON_KEY_MS
				);
			} else {
				this.closeCategoriesPanel();
				//clearTimeout(this.timer);
			}
		},

		caregorySelected(catText) {
			this.components.Autocomplete.fillAutocomplete(catText);
			this.closeCategoriesPanel();
		},

		hide() {
			this.closeCategoriesPanel();
		},

		clickInBackBtn(event) {
			this.widget.api.onClickBackMobile(event);
		}
	}
);



// WEBPACK FOOTER //
// ./src/components/mainBox/MainBox.js